import http, { jsonContentType, requestProxy } from "@/utils/request";
import { article } from "@/api/api";
import { oss } from "@/api/api";

//#region api请求
const requestForm = (url, data) => {
  return http
    .post({
      baseURL: requestProxy.api,
      url: url,
      data: data,
    })
    .then((res) => res.data);
};

const requestJson = (url, data) => {
  return http
    .post({
      baseURL: requestProxy.api,
      url: url,
      data,
      headers: { ...jsonContentType },
    })
    .then((res) => res.data);
};

const requestBlob = (url, data, params) => {
  return http
    .get({
      baseURL: requestProxy.api,
      url: url,
      data: data,
      params: params,
      responseType: "blob",
    })
    .then((res) => res.data);
};
//#endregion

export { requestForm, requestJson, requestBlob, article, oss };
